import { mapAssetsDocs } from "api/docs";
import { getAllUniqueFiles } from "api/fileManager";
import { getAllTags, getTagsByEquipmentsId, getTagsByTrainId, getTagsByUnitId, mapEquipmentTag, mapTrainTag, mapUnitTag } from "api/tags";

const mappingModalApiConfig = {
  mapAssetsDocs,
  getAllUniqueFiles,
  getAllTags,
  getTagsByEquipmentsId,
  getTagsByUnitId,
  getTagsByTrainId,
  mapEquipmentTag,
  mapUnitTag,
  mapTrainTag
};

export default mappingModalApiConfig;